import React from 'react';

const HeroHome = () => {
    return (
        <section className="heroHomeBox">
            <div className="heroBox">
                <h4 className="headingFour">Hey! This is Wasek Bellah</h4>

                <h1 className="headingPrimary">
                    <span style={{ marginLeft: "-300px" }}>I am A&nbsp;</span>
                    <span>
                        <span className="word">Web Developer.</span>
                        <span className="word">React Developer.</span>
                        <span className="word">WordPress Theme Developer.</span>
                        <span className="word">Responsive Website Designer.</span>
                        <span className="word">HTML CSS Developer.</span>
                    </span>
                </h1>

                <div className="heroButton">
                    <a href="#work" className="btn btn-white btnAnimated">Latest Work</a>
                </div>
            </div> {/* Hero Box */}
        </section>
    );
};

export default HeroHome;